import { Link } from '@custom/schema';
import { signIn, signOut, useSession } from 'next-auth/react';
import React from 'react';
import { useIntl } from '@amazeelabs/react-intl';
export function UserButton() {
    var session = useSession();
    var intl = useIntl();
    return /*#__PURE__*/ React.createElement(React.Fragment, null, !session && /*#__PURE__*/ React.createElement(React.Fragment, null), (session === null || session === void 0 ? void 0 : session.status) !== 'authenticated' && /*#__PURE__*/ React.createElement(Link, {
        href: '/api/auth/signin',
        className: "text-gray-500 underline",
        onClick: function(e) {
            e.preventDefault();
            signIn();
        }
    }, intl.formatMessage({
        defaultMessage: 'Sign in',
        id: 'SQJto2'
    })), (session === null || session === void 0 ? void 0 : session.status) === 'authenticated' && session.data.user && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Link, {
        href: "/".concat(intl.locale, "/profile"),
        className: "text-gray-700 mr-2"
    }, session.data.user.name ? session.data.user.name : session.data.user.email), /*#__PURE__*/ React.createElement(Link, {
        href: '/api/auth/signout',
        className: "text-gray-500",
        onClick: function(e) {
            e.preventDefault();
            signOut();
        }
    }, intl.formatMessage({
        defaultMessage: 'Sign out',
        id: 'xXbJso'
    }))));
}
